import * as type from '../actions/types';

const initialState = {
  saving: false,
  error: false,
  errorMessage: '',
  success: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.UPDATE_DEAL_PENDING:
      return {
        ...state,
        saving: true,
        error: false,
        errorMessage: '',
      };
    case type.UPDATE_DEAL_SUCCESS:
      return {
        ...state,
        saving: false,
        success: true,
      };
    case type.UPDATE_DEAL_FAILURE:
      return {
        ...state,
        error: true,
        errorMessage: action.payload,
        saving: false,
      };

    case type.CLEAR_DEAL:
      return {
        ...state,
        saving: false,
        error: false,
        errorMessage: '',
        success: false,
      };

    default:
      return state;
  }
};
